export default function imageToString(array: ArrayBuffer): string {
    return URL.createObjectURL(
        new Blob([new Uint8Array(array)])
    )
}
